import Vue from 'vue'

state =
    # the currently used sort-by option - matches the keys in state.keys
    choice: 'votes_imdb'

    # we keep a cached list of movie id's sorted by various properties.
    # This avoids re-sorting, which is relatively slow as the sorting must
    # happen over all movies.
    keys:
        votes_imdb: []
        score_imdb: []
        score_metacritic: []
        score_review: []
        time_collection: []
        time_release: []
        time_review: []

    titles:
        votes_imdb: "IMDb votes"
        score_imdb: "IMDb score"
        score_metacritic: "Metacritic score"
        score_review: "My review score"
        time_collection: "Collected time"
        time_release: "Released time"
        time_review: "My review time"

    descriptions:
        votes_imdb: "(default) Sort by the number of votes on IMDb, from high to low"
        score_imdb: "Sort by the score on IMDb, from high to low"
        score_metacritic: "Sort by the score on Metacritic, from high to low"
        score_review: "Sort by my own review score, from high to low"
        time_collection: "Sort by when the movie was added to my collection, from most recent to longest ago"
        time_release: "Sort by when the movie was released online, from most recent to longest ago"
        time_review: "Sort by when I reviewed the movie, from most recent to longest ago"

mutations =
    SET_CHOICE: (state, choice) ->
        state.choice = choice
    SORT_BY_SCORE_IMDB: (state, movies) ->
        ids = Array.from(movies.keys())
        ids.sort (a, b) ->
            score1 = movies.get(a).imdb_score
            score2 = movies.get(b).imdb_score
            return score2 - score1
        Vue.set(state.keys, 'score_imdb', ids)
    SORT_BY_SCORE_METACRITIC: (state, movies) ->
        ids = Array.from(movies.keys())
        ids.sort (a, b) ->
            score1 = movies.get(a).metacritic_score
            score2 = movies.get(b).metacritic_score
            return score2 - score1
        Vue.set(state.keys, 'score_metacritic', ids)
    SORT_BY_SCORE_REVIEW: (state, movies) ->
        ids = Array.from(movies.keys())
        ids.sort (a, b) ->
            score1 = movies.get(a).own_score
            score2 = movies.get(b).own_score
            return score2 - score1
        Vue.set(state.keys, 'score_review', ids)
    SORT_BY_TIME_COLLECTION: (state, movies) ->
        ids = Array.from(movies.keys())
        ids.sort (a, b) ->
            time1 = movies.get(a).collection_time
            time2 = movies.get(b).collection_time
            return 1 if not time1
            return -1 if not time2
            return if time2 < time1 then -1 else if time2 > time1 then 1 else 0
        Vue.set(state.keys, 'time_collection', ids)
    SORT_BY_TIME_RELEASE: (state, movies) ->
        ids = Array.from(movies.keys())
        ids.sort (a, b) ->
            time1 = movies.get(a).br1080p
            time2 = movies.get(b).br1080p
            return 1 if not time1
            return -1 if not time2
            return if time2 < time1 then -1 else if time2 > time1 then 1 else 0
        Vue.set(state.keys, 'time_release', ids)
    SORT_BY_TIME_REVIEW: (state, movies) ->
        ids = Array.from(movies.keys())
        ids.sort (a, b) ->
            time1 = movies.get(a).review_time
            time2 = movies.get(b).review_time
            return 1 if not time1
            return -1 if not time2
            return if time2 < time1 then -1 else if time2 > time1 then 1 else 0
        Vue.set(state.keys, 'time_review', ids)
    SORT_BY_VOTES_IMDB: (state, movies) ->
        ids = Array.from(movies.keys())
        ids.sort (a, b) ->
            votes1 = movies.get(a).imdb_votes
            votes2 = movies.get(b).imdb_votes
            return votes2 - votes1
        Vue.set(state.keys, 'votes_imdb', ids)

actions =
    preSortAll: ({ state, commit, rootState }) ->
        start = window.performance.now()

        movies = rootState.data.movies
        commit 'SORT_BY_SCORE_IMDB', movies
        commit 'SORT_BY_SCORE_METACRITIC', movies
        commit 'SORT_BY_SCORE_REVIEW', movies
        commit 'SORT_BY_TIME_COLLECTION', movies
        commit 'SORT_BY_TIME_RELEASE', movies
        commit 'SORT_BY_TIME_REVIEW', movies
        commit 'SORT_BY_VOTES_IMDB', movies

        time = window.performance.now() - start
        time = Math.floor(time * 100) / 100
        console.log "Sorted #{movies.size} items in #{time} ms"

export default {
    namespaced: true
    state
    mutations
    actions
}